import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

import { userData } from '../store/slice/user'
import { useAuth } from '../utils/auth'

const PrivateRoute = ({ children, ...props }) => {
  const auth = useAuth()
  const { accountID } = useSelector(userData)

  if (auth || accountID) {
    return children
  }

  return props.redirect ? <Navigate to={props.redirect} /> : <Navigate to="/" />
}
export default PrivateRoute
